export const useHttp = () => {
    const _apiBase = process.env.NODE_ENV === 'production' ? '/api/v1/' : 'http://cocktail/romashka-menu/api/v1/';

    const request = async (url, method = 'GET', body = null, headers = {'Content-Type': 'application/json'}) => {
        try {
            const response = await fetch(_apiBase + url, {method, body, headers});
        
            if (!response.ok) {
                let error = new Error(`Виникла непередбачувана помилка, повторіть запит або спробуйте пізніше.`);
                throw error;
            }
            
            const data = await response.json();
        
            return data;
        } catch(e) {
            let error = new Error('Виникла непередбачувана помилка, повторіть запит або спробуйте пізніше.');
            error.details = {
                message: 'Виникла непередбачувана помилка, повторіть запит або спробуйте пізніше.',
                error: 'Виникла непередбачувана помилка, повторіть запит або спробуйте пізніше.',
                type: 'any',
            };
            throw error;
        }
        
    };

    return {request};
}
